function removeImportantStyle(element, property) {
    const style = element.style.getPropertyValue(property);
    const priority = element.style.getPropertyPriority(property);

    if (style || priority) {
        const cleanedStyle = style.replace(/!important/g, '').trim();
        element.style.setProperty(property, cleanedStyle, '');
    }
}

const productSetCroMobileMedia = window.matchMedia('(max-width: 989px)');
const productSetCroOriginalBottomAttribute = 'productSetCroOriginalBottom';
const productSetCroOriginalBottomPriorityAttribute = 'productSetCroOriginalBottomPriority';
const productSetCroOriginalDisplayAttribute = 'productSetCroOriginalDisplay';
const productSetCroOriginalDisplayPriorityAttribute = 'productSetCroOriginalDisplayPriority';
const productSetCroHiddenAttribute = 'productSetCroHidden';
const productSetCroStickyOffset = 12;
const productSetCroShopifyInboxOffsetProperty = '--shopify-agent-activator-offset';
let chatAppFrame = null;

function isProductSetCroMobileActive() {
    const body = document.body;

    return !!body
        && productSetCroMobileMedia.matches
        && body.classList.contains('product-sets-sticky-cart-advanced')
        && body.classList.contains('is-ls-product-set-cro-active');
}

function hasStickyCart() {
    return !!document.querySelector('.product-sticky-cart');
}

function isMobileMenuActive() {
    const body = document.body;

    return !!body
        && (body.classList.contains('menu-mobile--opening')
            || body.classList.contains('menu-mobile--open')
            || body.classList.contains('menu-mobile--closing'));
}

function isProductSetCroWidgetOffsetEnabled() {
    const body = document.body;

    if (!body || !hasStickyCart()) return false;

    if (!productSetCroMobileMedia.matches) return true;
    if (isMobileMenuActive()) return false;
    if (body.classList.contains('is-ls-product-set-cro-expanded')) return false;

    return true;
}

function isProductSetCroWidgetSuppressed() {
    const body = document.body;

    if (!body || !productSetCroMobileMedia.matches || !hasStickyCart()) return false;
    if (isMobileMenuActive()) return true;

    return isProductSetCroMobileActive()
        && body.classList.contains('is-ls-product-set-cro-expanded');
}

function numericStyleValue(value) {
    const number = parseFloat(value);

    return Number.isFinite(number) ? number : null;
}

function hasStoredProductSetCroBottom(element) {
    return typeof element.dataset[productSetCroOriginalBottomAttribute] !== 'undefined';
}

function isShopifyInboxHost(element) {
    return element.matches('shopify-chat, shopify-agent, #shopify-chat, #ShopifyChat');
}

function usesShopifyInboxOffsetProperty(element) {
    return element.matches('shopify-chat, shopify-agent');
}

function productSetCroBottomProperty(element) {
    return usesShopifyInboxOffsetProperty(element)
        ? productSetCroShopifyInboxOffsetProperty
        : 'bottom';
}

function setElementBottom(element, value, priority) {
    const property = productSetCroBottomProperty(element);

    if (
        element.style.getPropertyValue(property) === value
        && element.style.getPropertyPriority(property) === priority
    ) {
        return;
    }

    element.style.setProperty(property, value, priority);
}

function setElementDisplay(element, value, priority) {
    if (
        element.style.getPropertyValue('display') === value
        && element.style.getPropertyPriority('display') === priority
    ) {
        return;
    }

    element.style.setProperty('display', value, priority);
}

function storeProductSetCroBottom(element) {
    if (hasStoredProductSetCroBottom(element)) return;

    const property = productSetCroBottomProperty(element);

    element.dataset[productSetCroOriginalBottomAttribute] = element.style.getPropertyValue(property) || '';
    element.dataset[productSetCroOriginalBottomPriorityAttribute] = element.style.getPropertyPriority(property) || '';
}

function storeProductSetCroDisplay(element) {
    if (typeof element.dataset[productSetCroOriginalDisplayAttribute] !== 'undefined') return;

    element.dataset[productSetCroOriginalDisplayAttribute] = element.style.getPropertyValue('display') || '';
    element.dataset[productSetCroOriginalDisplayPriorityAttribute] = element.style.getPropertyPriority('display') || '';
}

function restoreProductSetCroBottom(element) {
    if (!hasStoredProductSetCroBottom(element)) return;

    const property = productSetCroBottomProperty(element);
    const originalBottom = element.dataset[productSetCroOriginalBottomAttribute];
    const originalPriority = element.dataset[productSetCroOriginalBottomPriorityAttribute] || '';

    if (originalBottom) {
        setElementBottom(element, originalBottom, originalPriority);
    } else {
        element.style.removeProperty(property);
    }

    delete element.dataset[productSetCroOriginalBottomAttribute];
    delete element.dataset[productSetCroOriginalBottomPriorityAttribute];
}

function restoreProductSetCroDisplay(element) {
    if (typeof element.dataset[productSetCroOriginalDisplayAttribute] === 'undefined') return;

    const originalDisplay = element.dataset[productSetCroOriginalDisplayAttribute];
    const originalPriority = element.dataset[productSetCroOriginalDisplayPriorityAttribute] || '';

    if (originalDisplay) {
        setElementDisplay(element, originalDisplay, originalPriority);
    } else {
        element.style.removeProperty('display');
    }

    delete element.dataset[productSetCroOriginalDisplayAttribute];
    delete element.dataset[productSetCroOriginalDisplayPriorityAttribute];
    delete element.dataset[productSetCroHiddenAttribute];
}

function restoreProductSetCroWidget(element) {
    restoreProductSetCroBottom(element);
    restoreProductSetCroDisplay(element);
}

function managedProductSetCroWidgets() {
    return document.querySelectorAll('[data-product-set-cro-original-bottom]');
}

function hiddenProductSetCroWidgets() {
    return document.querySelectorAll('[data-product-set-cro-hidden]');
}

function stickyCartBottomOffset() {
    const stickyCart = document.querySelector('.product-sticky-cart');

    if (!stickyCart) return null;

    const style = window.getComputedStyle(stickyCart);
    const rect = stickyCart.getBoundingClientRect();

    if (
        style.display === 'none'
        || style.visibility === 'hidden'
        || numericStyleValue(style.opacity) === 0
        || rect.top >= window.innerHeight
        || rect.bottom <= 0
    ) {
        return null;
    }

    if (!rect.height) return null;

    return Math.ceil(rect.height) + productSetCroStickyOffset;
}

function isBottomPositioned(element, style, rect) {
    const bottom = numericStyleValue(style.bottom);

    return bottom !== null || rect.bottom >= window.innerHeight - 220;
}

function isCompactLauncher(element, maxHeight) {
    const rect = element.getBoundingClientRect();

    return rect.height === 0 || rect.height <= maxHeight;
}

function isVisibleLauncher(element, style, rect) {
    return style.display !== 'none'
        && style.visibility !== 'hidden'
        && rect.width > 0
        && rect.height >= 0;
}

function isWidgetVisibleLauncher(element) {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return isVisibleLauncher(element, style, rect)
        && isCompactLauncher(element, 160)
        && isBottomPositioned(element, style, rect);
}

function isCompactTawkIframe(element) {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    const zIndex = numericStyleValue(style.zIndex);
    const left = numericStyleValue(style.left);

    return style.position === 'fixed'
        && isVisibleLauncher(element, style, rect)
        && rect.height > 0
        && rect.height <= 100
        && (left === null ? rect.left <= 140 : left <= 140)
        && isBottomPositioned(element, style, rect)
        && zIndex !== null
        && zIndex >= 90000;
}

function isKlaviyoTeaser(element) {
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    const zIndex = numericStyleValue(style.zIndex);

    return style.position === 'fixed'
        && isVisibleLauncher(element, style, rect)
        && isCompactLauncher(element, 160)
        && isBottomPositioned(element, style, rect)
        && zIndex !== null
        && zIndex >= 90000;
}

function uniqueElements(elements) {
    return elements.filter((element, index) => elements.indexOf(element) === index);
}

function productSetCroLauncherCandidates() {
    return uniqueElements([
        ...document.querySelectorAll('.widget-visible, .widget-visible [title="chat widget"]'),
        ...document.querySelectorAll('iframe'),
        ...document.querySelectorAll('.needsclick[class*="kl-teaser-"], .needsclick[class*="kl-teaser"]'),
        ...document.querySelectorAll('shopify-chat, shopify-agent, #shopify-chat, #ShopifyChat, #ls-hide-shopify-inbox'),
    ]).filter((element) => {
        if (isShopifyInboxHost(element) || element.matches('#ls-hide-shopify-inbox')) {
            return true;
        }

        if (element.matches('.widget-visible, .widget-visible [title="chat widget"]')) {
            return isWidgetVisibleLauncher(element);
        }

        if (element.matches('iframe')) {
            return isCompactTawkIframe(element);
        }

        return isKlaviyoTeaser(element);
    });
}

function restoreUnmatchedProductSetCroWidgets(candidates) {
    const candidateSet = new Set(candidates);

    managedProductSetCroWidgets().forEach((element) => {
        if (!candidateSet.has(element)) {
            restoreProductSetCroBottom(element);
            restoreProductSetCroDisplay(element);
        }
    });
}

function suppressProductSetCroWidgets() {
    const candidates = uniqueElements([
        ...productSetCroLauncherCandidates(),
        ...hiddenProductSetCroWidgets(),
    ]);

    restoreUnmatchedProductSetCroWidgets(candidates);

    candidates.forEach((element) => {
        storeProductSetCroBottom(element);
        storeProductSetCroDisplay(element);
        element.dataset[productSetCroHiddenAttribute] = 'true';
        setElementDisplay(element, 'none', 'important');
    });
}

function syncProductSetCroWidgets() {
    if (isProductSetCroWidgetSuppressed()) {
        suppressProductSetCroWidgets();
        return;
    }

    if (!isProductSetCroWidgetOffsetEnabled()) {
        managedProductSetCroWidgets().forEach(restoreProductSetCroWidget);
        return;
    }

    const bottomOffset = stickyCartBottomOffset();

    if (bottomOffset === null) {
        managedProductSetCroWidgets().forEach(restoreProductSetCroWidget);
        return;
    }

    const candidates = uniqueElements([
        ...productSetCroLauncherCandidates(),
        ...hiddenProductSetCroWidgets(),
    ]);

    restoreUnmatchedProductSetCroWidgets(candidates);

    candidates.forEach((element) => {
        storeProductSetCroBottom(element);
        restoreProductSetCroDisplay(element);
        setElementBottom(element, bottomOffset + 'px', 'important');
    });
}

function syncChatApp() {
    const chatWidgets = document.querySelectorAll('.widget-visible [title="chat widget"]');

    chatWidgets.forEach((widgetElement) => {
        removeImportantStyle(widgetElement, 'transition');
        removeImportantStyle(widgetElement, 'transition-property');
        removeImportantStyle(widgetElement, 'bottom');
    });

    const isMiniCartOpen = document.body.classList.contains('mini-cart--open')
        || document.body.classList.contains('mini-cart--opening');

    if (isMiniCartOpen) {
        const widgetContainer = document.querySelector('.widget-visible');
        if (widgetContainer) {
            widgetContainer.style.setProperty('display', 'none', 'important');
        }
    }

    syncProductSetCroWidgets();
}

function scheduleChatAppSync() {
    if (chatAppFrame) return;

    chatAppFrame = requestAnimationFrame(() => {
        chatAppFrame = null;
        syncChatApp();
    });
}

const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
            scheduleChatAppSync();
            break;
        }
    }
});

const targetNode = document.body;
const observerConfig = {
    childList: true,
    subtree: true,
    attributes: true,
};

if (targetNode) {
    observer.observe(targetNode, observerConfig);
    scheduleChatAppSync();
}

if (productSetCroMobileMedia.addEventListener) {
    productSetCroMobileMedia.addEventListener('change', scheduleChatAppSync);
} else if (productSetCroMobileMedia.addListener) {
    productSetCroMobileMedia.addListener(scheduleChatAppSync);
}
